module.exports = __webpack_public_path__ + "static/media/code1.b6ab206a.jpg";